<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" absolute max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Price Info</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-checkbox
              :readonly="disabled"
              v-model="priceInfoToSave.allow_discount"
              label="Allow discount"
            />
            <v-checkbox
              :readonly="disabled"
              v-model="priceInfoToSave.taxable"
              label="Taxable"
            />

            <v-text-field
              readonly
              v-model="priceInfoToSave.price"
              label="Price"
            />
            <v-text-field
              readonly
              v-model="priceInfoToSave.lastsold"
              label="Last sold"
            />
            <v-text-field
              readonly
              v-model="priceInfoToSave.minimum_price"
              label="Minimum price"
            />
            <v-text-field
              readonly
              v-model="priceInfoToSave.total_sold"
              label="Total sold"
            />
            <v-text-field
              readonly
              v-model="priceInfoToSave.total_sold_12"
              label="Total sold 12"
            />
            <v-text-field
              readonly
              v-model="priceInfoToSave.total_sold_24"
              label="Total sold 24"
            />
            <v-text-field
              readonly
              v-model="priceInfoToSave.total_sold_36"
              label="Total sold 36"
            />

            <v-textarea
              auto-grow
              readonly
              label="Price Structure"
              v-model="priceInfoToSave.priceStructure"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="success" @click="handleSave" v-if="!disabled">
            Save
          </v-btn>
          <v-btn text color="blue darken-1" @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import * as _ from 'lodash';

export default {
  name: 'TaskCreationDialog',
  props: {
    priceInfo: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    row: {
      priceInfo: {}
    },
    priceInfoToSave: {},
    dialog: false,
    loading: false,
    disabled: false
  }),

  methods: {
    open(row, disabled) {
      this.disabled = disabled;
      this.row = row;
      const extendProperties = _.get(
        this.row,
        'priceStructure.extendProperties',
        {}
      );
      this.priceInfoToSave = {
        ...this.row.priceInfo,
        priceStructure: JSON.stringify(
          {
            ...this.row.priceStructure,
            extendProperties: {
              cost: this.row.cost,
              ...extendProperties
            }
          },
          undefined,
          4
        )
      };

      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    handleSave() {
      const priceInfo = {
        priceInfo: _.pick(this.priceInfoToSave, ['taxable', 'allow_discount'])
      };

      this.$emit('onRowUpdate', this.row.id, priceInfo);
    }
  }
};
</script>
